// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"569a00d1","667":"6523b191","977":"c8a62d49"}[chunkId] + ".chunk.js";
};